import React from "react";
import { Link } from "react-router-dom";
import { UncontrolledTooltip } from 'reactstrap';

const CommonToolTip = (props) => {
    return (
        <>
            <Link
                to={props.disabled ? undefined : props.to}
                onClick={props.disabled ? (e) => e.preventDefault() : props.onClick}
                className="text-dark"
                style={props.disabled ? { opacity: 0.4, pointerEvents: "none", cursor: "not-allowed" } : undefined}
            >
                <i className={props.class} id={props.id} aria-hidden="true"></i>
            </Link>
            <UncontrolledTooltip placement={props.placement} target={props.id}>
                {props.title}
            </UncontrolledTooltip>
        </>
    )
}

export default CommonToolTip;